import React from 'react';
import { Button } from '@fiverr-private/button';
import { useModalContext } from '@fiverr-private/overlay';
import { AppI18n } from '../../i18n';

export const CloseModal = () => {
  const { close } = useModalContext();

  return (
    <Button onClick={close}>
      <AppI18n k="how_to_modal_mira.cta" />
    </Button>
  );
};
